export default __webpack_public_path__ + "701c97c3061321b8285e19167f081cd4.png";